module.exports = __webpack_public_path__ + "img/nature-25.49c7cb31.jpg";